// removed by extract-text-webpack-plugin
module.exports = {"container":"maillist-module-container-d4279d248a744c4a574a99fc712859da--"};


//////////////////
// WEBPACK FOOTER
// /src/components/mailList/maillist.module.scss
// module id = 1996
// module chunks = 0